module.exports = __webpack_public_path__ + "img/bg_about_experience2.56895911.png";